import * as React from 'react';
import { Link, useLocation, useParams } from 'react-router-dom';
import { Breadcrumbs, Typography } from '@mui/material';
import { theme } from '../../theme';

const breadcrumbNameMap: { [key: string]: string } = {
  signup: 'Sign Up',
  signin: 'Sign In',
  'change-password': 'Change Password',
  'forgot-password': 'Forgot Password',
  otpverification: 'OTP Verification',
  accessdenied: 'Access Denied',
  thankyou: 'Thank You',
  linkexpired: 'Link Expired',
  declined: 'Declined',
  
  joblisting: 'Job Listing',
  'joblisting/create-job': 'Job Setup',

  users: 'User Management',
  panelstakeholders: 'Panel & Stakeholder Setup',

  communication: 'Communication',
  'communication/dashboard-messages': 'Dashboard Messages',
  'communication/email-templates': 'Email Templates',

  'preboarding-configuration':'Preboarding Configuration',
  'preboarding-configuration/offer-letter':'Offer Letter',
  'preboarding-configuration/candidate-details':'Candidate Details',
  'preboarding-configuration/documents':'Documents',
  'preboarding-configuration/hiring-experience':'Hiring Experience',


  hiringpipeline: 'Hiring Pipeline',
  assigntask: 'Assign Task',
  importprofiles: 'Import Profiles',
  candidatedetails: 'Candidate Details',

  'preboarding':'Preboarding',
  'preboarding/preboarding-summary':'Preboarding Summary',
  'preboarding/hired-candidates':'Hired Candidates',
  'preboarding/all-candidates':'All Candidates',

  'preboarding/all-candidates/candidate-preboarding': 'Candidate Preboarding',
  'preboarding/all-candidates/candidate-preboarding/candidate-offer': 'Offer Letter',






  importnewjob: 'Import New Job',
};


export default function CustomBreadcrumbs() {
  const location = useLocation();
  const { tenant } = useParams<{ tenant: string }>();

  const pathnames = location.pathname.split('/').filter(Boolean);
  const filteredPathnames = pathnames.slice(1); // Remove tenant

  const formatBreadcrumbLabel = (label: string) =>
    label
      .split('-')
      .map(word => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');

  return (
    <Breadcrumbs
      aria-label="breadcrumb"
      sx={{ py: '0.7vw', mb: '1vw', fontSize: '0.85rem' }}
    >
      {/* Home Icon Link */}
      <Link
        to={`/${tenant}/joblisting`}
        style={{
          textDecoration: 'none',
          color: theme.palette.text.secondary,
          display: 'flex',
          alignItems: 'center',
        }}
      >
        <i className="fa-solid fa-house" style={{ marginRight: '5px' }} />
      </Link>

      {/* Dynamic Breadcrumb Trail */}
      {filteredPathnames.map((value, index) => {
        const currentPath = filteredPathnames.slice(0, index + 1).join('/');
        const to = `/${tenant}/${currentPath}`;
        const isLast = index === filteredPathnames.length - 1;

        // Use exact match or fallback to formatted value
        const label =
          breadcrumbNameMap[currentPath.toLowerCase()] ||
          breadcrumbNameMap[value.toLowerCase()] ||
          formatBreadcrumbLabel(value);

        return isLast ? (
          <Typography
            key={to}
            color={theme.palette.text.secondary}
            sx={{ fontWeight: 500 }}
          >
            {label}
          </Typography>
        ) : (
          <Link
            key={to}
            to={to}
            state={location.state}
            style={{
              textDecoration: 'none',
              color: theme.palette.text.secondary,
            }}
          >
            {label}
          </Link>
        );
      })}
    </Breadcrumbs>
  );
}
